module.exports = __webpack_public_path__ + "media/images/official/voice_misaki-8c39f1653c4c143924a0a137904f06d8.png";